import * as Yup from 'yup';

export const desingAnalysisFormSchema = Yup.object().shape({
  conditionedArea: Yup.string().required('ACH Area is required'),
  volume: Yup.string().required('Volume is required'),
  windowArea: Yup.string().required('Window Area is required'),
  airflow: Yup.string().required('Airflow is required'),
  // bluePrint: Yup.string().required('Blueprint is required'),
});
